/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker, NumberFilterInput } from 'components/filters';
import {
  CopackAgreementSelect,
  OrderBrokerageAgreementSelect,
} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
import RequiresRole from 'flaivy-react/components/RequiresRole';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function SettlementFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.settlementNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.settlementState === 'undefined' && (
          <FormGroup>
            <Label>Status</Label>
            <Select
              instanceId="select-settlementState"
              name="settlementState"
              value={_.get(resolvedQuery, 'settlementState', '')}
              onChange={handleChange}
              options={[
                { value: 'created', label: 'Skapad' || 'created' },
                {
                  value: 'sentToSupplierOrganization',
                  label: 'Skickad' || 'sentToSupplierOrganization',
                },
                {
                  value: 'invoiceReceivedFromSupplierOrganization',
                  label:
                    'Mottagen av Flaivy' ||
                    'invoiceReceivedFromSupplierOrganization',
                },
                {
                  value: 'invoiceCompleted',
                  label: 'Bokförd' || 'invoiceCompleted',
                },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.cancelled === 'undefined' && (
          <FormGroup>
            <Label>Makulerad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'cancelled') === undefined}
                onClick={() => {
                  handleChange('cancelled', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === true ||
                  _.get(resolvedQuery, 'cancelled') === 'true'
                }
                onClick={() => {
                  handleChange('cancelled', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === false ||
                  _.get(resolvedQuery, 'cancelled') === 'false'
                }
                onClick={() => {
                  handleChange('cancelled', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.copackAgreement === 'undefined' && (
          <FormGroup>
            <Label>Copack-avtal</Label>
            <CopackAgreementSelect
              defaultOptions={false}
              instanceId="select-copackAgreement"
              name="copackAgreement"
              value={_.get(resolvedQuery, 'copackAgreement')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderBrokerageAgreement === 'undefined' && (
          <FormGroup>
            <Label>Ordermäklaravtal</Label>
            <OrderBrokerageAgreementSelect
              defaultOptions={false}
              instanceId="select-orderBrokerageAgreement"
              name="orderBrokerageAgreement"
              value={_.get(resolvedQuery, 'orderBrokerageAgreement')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.invoiceId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.startDate === 'undefined' && (
          <FormGroup>
            <Label>Rapportens startdatum</Label>
            <DateRangePicker
              name="startDate"
              value={_.get(resolvedQuery, 'startDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.endDate === 'undefined' && (
          <FormGroup>
            <Label>Rapportens slutdatum</Label>
            <DateRangePicker
              name="endDate"
              value={_.get(resolvedQuery, 'endDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.settlementOrderValue === 'undefined' && (
          <FormGroup>
            <Label>avräkningens ordervärde</Label>
            <NumberFilterInput
              name="settlementOrderValue"
              value={_.get(resolvedQuery, 'settlementOrderValue')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalAlcoholTaxIncDiscount === 'undefined' && (
          <FormGroup>
            <Label>Total alkoholskatt inklusive avdrag</Label>
            <NumberFilterInput
              name="totalAlcoholTaxIncDiscount"
              value={_.get(resolvedQuery, 'totalAlcoholTaxIncDiscount')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalAlcoholTax === 'undefined' && (
          <FormGroup>
            <Label>Total alkoholskatt</Label>
            <NumberFilterInput
              name="totalAlcoholTax"
              value={_.get(resolvedQuery, 'totalAlcoholTax')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalPostponedAlcoholTax === 'undefined' && (
          <FormGroup>
            <Label>Total EMCS alkoholskatt</Label>
            <NumberFilterInput
              name="totalPostponedAlcoholTax"
              value={_.get(resolvedQuery, 'totalPostponedAlcoholTax')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalInvoicedBySupplierOrganization ===
          'undefined' && (
          <FormGroup>
            <Label>Belopp som leverantören har fakturerat</Label>
            <NumberFilterInput
              name="totalInvoicedBySupplierOrganization"
              value={_.get(
                resolvedQuery,
                'totalInvoicedBySupplierOrganization',
              )}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalCommission === 'undefined' && (
          <FormGroup>
            <Label>Total provision</Label>
            <NumberFilterInput
              name="totalCommission"
              value={_.get(resolvedQuery, 'totalCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalAdjustment === 'undefined' && (
          <FormGroup>
            <Label>Total justering</Label>
            <NumberFilterInput
              name="totalAdjustment"
              value={_.get(resolvedQuery, 'totalAdjustment')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.totalToBill === 'undefined' && (
          <FormGroup>
            <Label>Belopp att fakturera</Label>
            <NumberFilterInput
              name="totalToBill"
              value={_.get(resolvedQuery, 'totalToBill')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.serviceAgreement === 'undefined' && (
          <FormGroup>
            <Label>Serviceavtal</Label>
            <Select
              type="string"
              instanceId="select-serviceAgreement"
              name="serviceAgreement"
              value={_.get(resolvedQuery, 'serviceAgreement')}
              onChange={handleChange}
              options={[
                {
                  label:
                    'v2.5 - minimum serviceavgift och taggade kunder - Använder order och reklamationer',
                  value: 'v2.5',
                },
                { label: 'v3', value: 'v3' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        <RequiresRole requiredRoles={['super']}>
          {typeof immutableQuery.totalCost === 'undefined' && (
            <FormGroup>
              <Label>Totalkostnad för leverantören över perioden</Label>
              <NumberFilterInput
                name="totalCost"
                value={_.get(resolvedQuery, 'totalCost')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.VATSummary === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.receiverCompanyName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.receiverAddress === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.receiverZipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.receiverCity === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.receiverOrganisationNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.settlementRows === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

SettlementFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

SettlementFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function SettlementFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <SettlementFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

SettlementFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

SettlementFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { SettlementFilterPanel, SettlementFilterPanelModal };
